import {Directive, ElementRef, HostBinding, Input} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {HistInfo} from "../../core/gb-api";

@Directive({
  selector: '[capHistinfo]',

})
export class HistoryDirective {

  private _capHistinfo: HistInfo;

  @HostBinding('attr.aria-label')
  ariaLabel: string;

  private class: string;

  constructor(private elementRef: ElementRef, private translate: TranslateService) {
  }

  @Input()
  set capHistinfo(value: HistInfo) {
    if (!value) {
      return;
    }
    this._capHistinfo = value;
    if (!this._capHistinfo) {
      return;
    }
    const hist = this._capHistinfo ? this._capHistinfo.histEnum.toLowerCase() : '';
    this.setClass(hist);
    this.ariaLabel = hist ? this.translate.instant(hist) : undefined;
  }

  setClass(newClass) {
    const el = <HTMLElement> this.elementRef.nativeElement;
    if (this.class) {
      el.classList.remove(this.class);
    }
    this.class = newClass;
    if (this.class) {
      el.classList.add(this.class);
    }
  }

}
